/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { ColumnDef } from '@tanstack/react-table';
import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Space,
  Stack,
  Text,
} from '@tonic-one/react';
import { useToggle } from '@tonic-one/react-hooks';
// import { calcDaysBetween } from '../../../utils/time';
import dayjs from 'dayjs';
import React, {
  memo,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { PolicyApi } from '@Apis';
import { Info } from '../../../../components/Common/Info';
import { SERVICE_ID_NAME_MAP } from '../../../../utils/service';
import LoadingBtn from '../../../Report/LoadingBtn';
import TimeRange from '../../TimeRange';
import { PolicyTypeEnum } from '../../utils/constants';
import {
  OverAllPolicyType,
  PolicyListModalName,
  PolicyListModalState,
  ScanScopeType,
  ScanType,
} from '../../utils/types';
import { PolicyRulesCell } from '../../TableCell';
import CommonTable from '../../../../components/Common/Table';
import { ValidProps } from '@Types/index';
import { validateEmailsWithSemicolon } from '@Utils/common';
import { convertLocalTimeToUtcTimeZZ } from '@Utils/time';
import {
  InputChildRef,
  InputWithValid,
} from '@Components/Common/Form/InputWithValid';
import Note from '@Components/Common/Note';
import { useLicenseStore } from '@Models/useLicenseModel';
import customConfig from '../../../../config';
import { OverAllPolicyTypeContext } from '@Policy/OverAllPolicyList/context/OverAllPolicyTypeContext';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

interface TableData {
  policyName: string;
  policyType: PolicyTypeEnum;
  policyTarget: string;
  scanDetails: string;
  isAsEnabled: boolean;
  isVsEnabled: boolean;
  isFbEnabled: boolean;
  isWtpEnabled: boolean;
  isDdaEnabled: boolean;
  isDpEnabled: boolean;
  isKfEnabled: boolean;
  isSlfEnabled: boolean;
  isRaiEnabled: boolean;
  policySubType: number;
}

export interface ManualScanInfo {
  policyId: string;
  policyHolderType: number;
  policyType: PolicyTypeEnum;
  throttlingNumber: number;
  scanType: ScanType;
  scopeType: ScanScopeType;
  value: string[];
  localTime: (string | number)[];
  recipients: string;
}

export interface ManualScanCancelAndRescanInfo {
  policyType: PolicyTypeEnum;
}

export const ScanModal = ({
  modal,
  setModal,
  setRefreshTableTrigger,
}: {
  modal: PolicyListModalState;
  setModal: ({ name, policy }: PolicyListModalState) => void;
  setRefreshTableTrigger: (trigger: Date) => void;
}) => {
  if (modal.name !== 'scan') {
    return <></>;
  }
  const { t } = useTranslation();
  const licenseModel = useLicenseStore();
  const [policyGetTargetNumberStatus, togglePolicyGetTargetNumberStatus] =
    useToggle(false);
  const [policyTargetCount, setPolicyTargetCount] = useState<number>(0);
  const [throttlingNumber, setThrottlingNumber] = useState<number>(0);
  const [scanType, setScanType] = useState<ScanType>(ScanType.ScanAndProtect);
  //scan scope status
  const [scopeType, setScopeType] = useState<ScanScopeType>(
    ScanScopeType.FixedDay
  );
  const [fixedDays, setFixedDays] = useState(1);
  const [customTime, setCustomTime] = useState({
    startDate: dayjs().subtract(10, 'days').toDate(),
    startTime: '00:00:00',
    endDate: dayjs().toDate(),
    endTime: dayjs().format('HH:mm:ss'),
  });
  const [tableData, setTableData] = useState<TableData>({
    policyName: modal.policy.policyName,
    policyTarget: '',
    scanDetails: '',
    policyType: modal.policy.policyType,
    isAsEnabled: false,
    isVsEnabled: false,
    isFbEnabled: false,
    isWtpEnabled: false,
    isDdaEnabled: false,
    isDpEnabled: false,
    isKfEnabled: false,
    isSlfEnabled: false,
    isRaiEnabled: false,
    policySubType: modal.policy.policySubType,
  });
  const [recipients, setRecipients] = useState<string>('');
  const [loading, toggleLoading] = useToggle(false);
  const ManualScanTrialUserAllowTargetCountMap = {
    [PolicyTypeEnum.Exchange]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.email,
      alertText: t('policy.manualScan.trialUser.alert.Exchange'),
    },
    [PolicyTypeEnum.SharePoint]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.others,
      alertText: t('policy.manualScan.trialUser.alert.SharePoint'),
    },
    [PolicyTypeEnum.OneDrive]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.others,
      alertText: t('policy.manualScan.trialUser.alert.OneDrive'),
    },
    [PolicyTypeEnum.Box]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.others,
      alertText: t('policy.manualScan.trialUser.alert.Box'),
    },
    [PolicyTypeEnum.Dropbox]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.others,
      alertText: t('policy.manualScan.trialUser.alert.Dropbox'),
    },
    [PolicyTypeEnum.GoogleDrive]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.others,
      alertText: t('policy.manualScan.trialUser.alert.GoogleDrive'),
    },
    [PolicyTypeEnum.Gmail]: {
      maxTarget: customConfig.ui.policy.manualScanTrailUserAllow.email,
      alertText: t('policy.manualScan.trialUser.alert.Gmail'),
    },
  };
  const overAllPolicyType = useContext(OverAllPolicyTypeContext);
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const manualScanExtendDays =
    selectedOrgGlobalSetting?.manualScanExtendDays &&
    selectedOrgGlobalSetting?.manualScanExtendDays === 365
      ? 365
      : 31;
  const onClose = () => {
    setModal({
      name: PolicyListModalName.None,
      policy: null,
    });
  };
  const validate: ValidProps[] = [
    {
      validMethod: validateEmailsWithSemicolon,
      errMsg: t('common.error.invalidEmailAddress'),
    },
  ];
  const inputChildRef = useRef<InputChildRef>(null);
  const getEstimateTimeString = (days: number) => {
    let userNumber = 0;
    if (policyGetTargetNumberStatus && policyTargetCount) {
      userNumber = policyTargetCount;
    }

    let timeCost: number;
    const _throttlingNumber = throttlingNumber || userNumber || 1;
    if (userNumber <= _throttlingNumber) {
      if (userNumber <= 75) {
        timeCost = 4 * days + 2;
      } else if (userNumber <= 150) {
        timeCost = 8 * days + 2;
      } else {
        timeCost = 10 * days + 2;
      }
    } else {
      timeCost =
        ((userNumber + _throttlingNumber - 1) / _throttlingNumber) * 10 * days +
        2;
      if (userNumber > 400) {
        timeCost += 8;
      }
    }
    //judge timeCost large than one day
    const isTimeCostFullDay = timeCost > 24 * 60;

    let estimateTime = timeCost / (isTimeCostFullDay ? 24 * 60 : 60);
    let estimateTimeStringKey = '';
    if (!isTimeCostFullDay) {
      if (estimateTime < 1) {
        estimateTimeStringKey =
          'policy.modals.manualScan.estimationTimeByMinutes';
        estimateTime *= 60;
      } else {
        estimateTimeStringKey =
          'policy.modals.manualScan.estimationTimeByHours';
      }
    } else {
      estimateTimeStringKey = 'policy.modals.manualScan.estimationTimeByDays';
    }
    return t(estimateTimeStringKey, { NUMBER: estimateTime.toFixed(1) });
  };

  const onScanNow = async () => {
    if (!checkTrialUserTargetCount()) {
      window.showNotification({
        titleMsg:
          ManualScanTrialUserAllowTargetCountMap[
            modal.policy
              .policyType as keyof typeof ManualScanTrialUserAllowTargetCountMap
          ].alertText,
        severity: 'error',
      });
      return;
    }
    await inputChildRef.current?.validate(recipients);
    if (inputChildRef.current?.errorMsg !== undefined) return;
    toggleLoading(true);
    const localTime =
      scopeType === ScanScopeType.FixedDay
        ? [fixedDays.toString(), 'day', new Date().getTimezoneOffset()]
        : [
            dayjs(customTime.startDate).format('YYYY-MM-DD') +
              ' ' +
              customTime.startTime.substring(0, 5),
            dayjs(customTime.endDate).format('YYYY-MM-DD') +
              ' ' +
              customTime.endTime.substring(0, 5),
            new Date().getTimezoneOffset(),
          ];
    const value =
      scopeType === ScanScopeType.FixedDay
        ? [fixedDays.toString(), 'day']
        : [
            convertLocalTimeToUtcTimeZZ(localTime[0] as string),
            convertLocalTimeToUtcTimeZZ(localTime[1] as string),
          ];
    const manualScanInfo: ManualScanInfo = {
      policyId: modal.policy?.policyUuid,
      // policyHolderType为1是atp
      policyHolderType: overAllPolicyType === OverAllPolicyType.ATP ? 1 : 2,
      policyType: modal.policy?.policyType,
      throttlingNumber: modal.policy?.throttling_number || 0,
      scanType,
      scopeType,
      value,
      localTime,
      recipients,
    };
    await PolicyApi.runManualScan(manualScanInfo);
    setModal({
      name: PolicyListModalName.None,
      policy: null,
    });
    setRefreshTableTrigger(new Date());
    setRecipients('');
    toggleLoading(false);
  };

  const checkTrialUserTargetCount = () => {
    const isTrialUser = isTrialUserByPolicyType(modal.policy.policyType);
    if (isTrialUser) {
      const allowedTargetUsersInfo =
        ManualScanTrialUserAllowTargetCountMap[
          modal.policy
            .policyType as keyof typeof ManualScanTrialUserAllowTargetCountMap
        ];
      if (!(policyTargetCount <= allowedTargetUsersInfo.maxTarget)) {
        return false;
      }
    }
    return true;
  };

  const isTrialUserByPolicyType = (policyType: PolicyTypeEnum) => {
    if (
      (policyType === PolicyTypeEnum.SalesforceSandbox ||
        policyType === PolicyTypeEnum.SalesforceProduction) &&
      licenseModel.license['CAS-SF']
    ) {
      return licenseModel.license['CAS-SF'].type === 'trial';
    } else if (licenseModel.license.CAS) {
      return licenseModel.license.CAS.type === 'trial';
    }
    return true;
  };

  useEffect(() => {
    (async () => {
      try {
        togglePolicyGetTargetNumberStatus(false);
        const data = (
          await PolicyApi.getPolicyTargetCount(
            modal.policy.policyType,
            modal.policy.policyUuid
          )
        ).data;
        togglePolicyGetTargetNumberStatus(true);
        setPolicyTargetCount(data.targetCount);
        setThrottlingNumber(data.throttlingNumber);
      } catch (error) {
        //alert
        console.error(JSON.stringify(error));
      }
    })();
    setTableData({
      policyName: modal.policy.policyName,
      policyTarget: modal.policy.policyTarget,
      scanDetails: getEstimateTimeString(1),
      policyType: modal.policy.policyType,
      isAsEnabled: modal.policy.isAsEnabled,
      isVsEnabled: modal.policy.isVsEnabled,
      isFbEnabled: modal.policy.isFbEnabled,
      isWtpEnabled: modal.policy.isWtpEnabled,
      // manual scan 不涉及 va
      isDdaEnabled: false,
      isDpEnabled: modal.policy.isDpEnabled,
      isKfEnabled: modal.policy.isKfEnabled,
      isSlfEnabled: modal.policy.isSlfEnabled,
      isRaiEnabled: false,
      policySubType: modal.policy.policySubType,
    });
  }, []);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modal.name === PolicyListModalName.Scan}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent overflow="visible">
        <ModalHeader>
          {overAllPolicyType === OverAllPolicyType.ATP
            ? t('policy.modals.manualScan.atp.title')
            : t('policy.modals.manualScan.dlp.title')}
        </ModalHeader>
        <ModalBody overflow="visible">
          <Flex flexDirection="column">
            <Text paddingY="12px">
              {t('policy.modals.manualScan.selectedPolicy.title')}
            </Text>
            <ManualScanTable
              data={tableData}
              overAllPolicyType={overAllPolicyType}
            />
            {/*storage 无scan type*/}
            {modal.policy.policyType !== PolicyTypeEnum.Box &&
              modal.policy.policyType !== PolicyTypeEnum.Dropbox &&
              modal.policy.policyType !== PolicyTypeEnum.GoogleDrive && (
                <Flex flexDirection="column">
                  <Space height="12px"></Space>
                  <Text>{t('policy.modals.manualScan.scanType.title')}</Text>
                  <ScanTypeCheckBoxGroup
                    scanType={scanType}
                    setScanType={setScanType}
                  />
                </Flex>
              )}
            <Text>{t('policy.modals.manualScan.scanScope.title')}</Text>
            <Space height="12px" />
            <RadioGroup
              value={scopeType}
              onChange={(value: ScanScopeType) => setScopeType(value)}
            >
              <Stack spacing="1x" shouldWrapChildren>
                <Radio value={ScanScopeType.FixedDay}>
                  <Flex align="center">
                    <Text flex="max-content">
                      {t('policy.modals.manualScan.scanScope.recently')}:
                    </Text>
                    <Input
                      type="number"
                      min={1}
                      max={manualScanExtendDays}
                      mx="2x"
                      value={fixedDays}
                      width="80px"
                      onChange={(e: any) => {
                        // 1 <= value <= 31
                        const value = Math.min(
                          Math.max(e.target.value, 1),
                          manualScanExtendDays
                        );
                        setFixedDays(value);
                        setTableData({
                          ...tableData,
                          scanDetails: getEstimateTimeString(value),
                        });
                      }}
                    />
                    <Text>{t('policy.modals.manualScan.scanScope.days')}</Text>
                  </Flex>
                </Radio>
                <Radio value={ScanScopeType.Custom} mt="8px">
                  <Flex align="center">
                    <Text>{t('policy.modals.manualScan.scanScope.from')}:</Text>
                    <Space width="27px" />
                    <TimeRange range={customTime} setRange={setCustomTime} />
                  </Flex>
                </Radio>
              </Stack>
            </RadioGroup>
            {/*box dropbox googleDrive无report recipients*/}
            <Space height="16px" />
            {modal.policy.policyType !== PolicyTypeEnum.Box &&
              modal.policy.policyType !== PolicyTypeEnum.Dropbox &&
              modal.policy.policyType !== PolicyTypeEnum.GoogleDrive && (
                <Space height="12px" />
              ) && (
                <Flex flexDirection="column">
                  <Text>{t('policy.modals.manualScan.recipients.title')}</Text>
                  <Space height="12px" />
                  <InputWithValid
                    ref={inputChildRef}
                    placeholder={t('policy.placeholder.inputEmailAddresses')}
                    width="75%"
                    value={recipients}
                    onChange={(e: any) => {
                      setRecipients(e);
                    }}
                    validates={validate}
                    maxLength={1024}
                  />
                </Flex>
              )}
            <Space height="12px" />
            <Note content={t('policy.tips.hints.scaNotIncludeVA')} />
          </Flex>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn loading={loading} onClick={onScanNow} variant="primary">
            {t('policy.button.scanNow')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const ManualScanTable = memo(
  ({
    data,
    overAllPolicyType,
  }: {
    data: TableData;
    overAllPolicyType: OverAllPolicyType;
  }) => {
    const { t } = useTranslation();

    const manualScanColumns: ColumnDef<TableData>[] = useMemo(
      () => [
        {
          id: 'policyName',
          header: t('policy.table.fields.policyName'),
          accessorKey: 'policyName',
          size: 143,
        },
        {
          id: 'policyType',
          header: t('policy.table.fields.policyType'),
          accessorFn: ({ policyType }) =>
            t('common.service.' + SERVICE_ID_NAME_MAP[policyType]) as string,
          size: 134,
        },
        {
          id: 'policyTarget',
          header: t('policy.table.fields.policyTarget'),
          accessorKey: 'policyTarget',
          size: 128,
        },
        {
          id: 'policyRule',
          header: t('policy.table.fields.policyRule'),
          cell: ({ row }) => {
            return (
              <PolicyRulesCell type={overAllPolicyType} policy={row.original} />
            );
          },
          size: 285,
          meta: {
            needOverflowTooltip: false,
          },
        },
        {
          id: 'scanDetails',
          header: t('policy.table.fields.scanDetails'),
          accessorKey: 'scanDetails',
          size: 280,
        },
      ],
      []
    );

    return (
      <CommonTable<TableData>
        data={[data]}
        columns={manualScanColumns}
        identityKeys={['scanDetails']}
      />
    );
  }
);

export const ScanTypeCheckBoxGroup = memo(
  ({
    scanType,
    setScanType,
    withEditPermission = true,
  }: {
    scanType: ScanType;
    setScanType?: Function;
    withEditPermission?: boolean;
  }) => {
    const { t } = useTranslation();
    return (
      <Flex align="center" py="16px">
        <RadioGroup
          value={scanType}
          onChange={(value: ScanType) =>
            setScanType ? setScanType(value) : null
          }
          disabled={!withEditPermission}
        >
          <Stack direction="row" spacing="40px">
            <Radio value={ScanType.ScanAndProtect}>
              {t('policy.modals.manualScan.scanType.scanAndProtect')}
            </Radio>
            <Radio value={ScanType.ScanOnly}>
              {t('policy.modals.manualScan.scanType.scanOnly')}
              <Info
                content={t('policy.modals.manualScan.scanType.scanOnlyTip')}
                iconStyle={{ ml: '2x' }}
              />
            </Radio>
          </Stack>
        </RadioGroup>
      </Flex>
    );
  }
);
